//
// Хук для запроса к API
//
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get, post, put, del } from './api';

const useApi = ({ type, method, params }) => {
    const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true);
            setData(null);
			setError('');
            let result;
            switch(type) {
                case 'get':
                    result = await get(method, params);
                    break;
                case 'post':
                    result = await post(method, params);
                    break;
                case 'put':
                    result = await put(method, params);
                    break;
                case 'delete':
                    result = await del(method, params);
                    break;
                default:
                    result = null;
                    break;
            }
            if(result) {
                if(result.error) {
                    setError(result.error);
                } else {
                    setData(result.data);
                }
            }
			setIsLoading(false);
		};

		fetchData();
	}, [type, method, params]);

    return [ data, error, isLoading ];
};

useApi.propTypes = {
    type: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
};

useApi.defaultProps = {
    type: 'get',
    method: '/',
	params: {},
};

export default useApi;
